import {
  Clapperboard,
  Plane,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  Sparkles,
  UtensilsCrossed,
} from "lucide-react";

export const MAP_LINK =
  "https://www.google.com/maps/place/Incer+Technovation+Private+limited/@11.3435962,77.694131,17z/data=!4m14!1m7!3m6!1s0x3ba96f369d385175:0xdb068695c171ffc6!2sIncer+Technovation+Private+limited!8m2!3d11.3435962!4d77.6967059!16s%2Fg%2F11m6pqs8sx!3m5!1s0x3ba96f369d385175:0xdb068695c171ffc6!8m2!3d11.3435962!4d77.6967059!16s%2Fg%2F11m6pqs8sx?entry=ttu";

export const INDUSTRIES = [
  { name: "Consumer Brands", Icon: ShoppingBag },
  { name: "E-commerce & D2C", Icon: ShoppingCart },
  { name: "Fashion & Lifestyle", Icon: Shirt },
  { name: "Beauty & Personal Care", Icon: Sparkles },
  { name: "Food & Beverage", Icon: UtensilsCrossed },
  { name: "Technology & Apps", Icon: Smartphone },
  { name: "Travel & Hospitality", Icon: Plane },
  { name: "Entertainment & Media", Icon: Clapperboard },
];

export const REGIONAL_LANGUAGES = [
  { code: "EN", name: "English", note: "Global reach with native English speakers" },
  { code: "TA", name: "Tamil", note: "South India's largest creator economy" },
  { code: "ML", name: "Malayalam", note: "Kerala's high-engagement audience" },
  { code: "TE", name: "Telugu", note: "Andhra Pradesh & Telangana reach" },
  { code: "KN", name: "Kannada", note: "Karnataka's premium creators" },
  { code: "HI", name: "Hindi", note: "India's largest language with 600M+ speakers" },
  { code: "+", name: "& more..", note: "& more.." },
  // { code: "MR", name: "Marathi", note: "Maharashtra's vibrant creator community" },
  // { code: "PA", name: "Punjabi", note: "Punjab's influential creators" },
  // { code: "BN", name: "Bengali", note: "Bengal's creator network" },
  // { code: "OR", name: "Oriya", note: "Odisha's regional influencers" },
  // { code: "GU", name: "Gujarati", note: "Gujarat's growing creator economy" },
  // { code: "UR", name: "Urdu", note: "Urdu-speaking regions" },
];

export const HOME_FAQS = [
  {
    q: "What is Incer?",
    a: "Incer is a strategy-driven influencer marketing platform that helps brands and agencies discover verified creators, manage campaigns, and track performance with real-time analytics.",
  },
  {
    q: "Who can use Incer?",
    a: "Incer is built for brands, marketing teams and agencies running influencer marketing campaigns — from regional and hyperlocal pushes to large-scale national collaborations.",
  },
  {
    q: "What kind of creators does Incer work with?",
    a: "We work with nano, micro, macro and regional creators across niches like beauty, fashion, food, tech, travel, fitness and lifestyle — including South Indian Tamil, Telugu, Malayalam and Kannada creators.",
  },
  {
    q: "How are campaigns measured?",
    a: "Every campaign is tracked through real-time insights covering engagement, reach, content performance and overall campaign impact — so you always know what's working.",
  },
];

export const BRANDS_FAQS = [
  {
    q: "What is the Incer influencer marketing platform?",
    a: "Incer is a strategy-driven influencer marketing platform that helps brands discover creators, manage influencer campaigns, and track campaign performance through real-time insights.",
  },
  {
    q: "How does Incer help brands find influencers?",
    a: "Incer provides influencer discovery tools that help brands identify creators based on audience demographics, niche, location, and engagement insights.",
  },
  {
    q: "Can brands run regional influencer campaigns through Incer?",
    a: "Yes. Incer enables brands to collaborate with regional and hyperlocal influencers across multiple markets, helping brands reach diverse audiences.",
  },
  {
    q: "How can brands measure influencer campaign performance?",
    a: "Incer provides campaign analytics and performance insights that allow brands to monitor engagement, reach, and overall campaign impact.",
  },
  {
    q: "Who can use the Incer platform?",
    a: "Incer is designed for brands, marketing teams, and agencies looking to run strategic and scalable influencer marketing campaigns.",
  },
];

export const CREATOR_FAQS = [
  {
    q: "What is Incer for creators?",
    a: "Incer is an influencer marketing platform that connects creators with brands for collaborations and campaigns.",
  },
  {
    q: "How can I join Incer?",
    a: "You can sign up by creating your profile and sharing your social media details. Our team will review your profile.",
  },
  {
    q: "Do I need a minimum number of followers?",
    a: "Incer works with creators of different sizes, including micro and niche creators with engaged audiences.",
  },
  {
    q: "What type of campaigns can I get?",
    a: "Creators can participate in influencer campaigns, brand collaborations, and UGC campaigns.",
  },
  {
    q: "How will I get brand opportunities?",
    a: "Brands discover creators through the platform based on niche, audience, and campaign requirements.",
  },
  {
    q: "Is there any cost to join Incer?",
    a: "No, joining Incer as a creator is free.",
  },
];

export const UGC_FAQS = [
  {
    q: "What is UGC in marketing?",
    a: "UGC (User-Generated Content) is content created by creators that showcases a brand in a natural, authentic way.",
  },
  {
    q: "How is UGC different from influencer marketing?",
    a: "UGC focuses on content creation for brand usage, while influencer marketing focuses on content posted on the creator's platform.",
  },
  {
    q: "How does Incer help with UGC?",
    a: "Incer connects brands with creators who can produce high-quality UGC content aligned with brand goals.",
  },
  {
    q: "Where can brands use UGC content?",
    a: "UGC can be used on social media, paid ads, websites, and marketing campaigns.",
  },
  {
    q: "Is UGC suitable for all brands?",
    a: "Yes. UGC works well for e-commerce, D2C, lifestyle, beauty, tech, and many other industries.",
  },
];

export const AGENCY_FAQS = [
  {
    q: "What does Incer specialize in?",
    a: "Incer specializes in influencer marketing, UGC content creation, regional creator campaigns, and bulk influencer campaign execution.",
  },
  {
    q: "Does Incer work with agencies?",
    a: "Yes. We work as an execution and influencer marketing partner for agencies and brands across multiple industries.",
  },
  {
    q: "Can Incer handle bulk influencer campaigns?",
    a: "Yes. We specialize in high-volume influencer campaigns with nano, micro, and regional creators across India.",
  },
  {
    q: "Do you provide UGC creators?",
    a: "Yes. We provide UGC creators for product videos, testimonial content, ad creatives, Instagram reels, and performance marketing campaigns.",
  },
  {
    q: "Which regions do you cover?",
    a: "We primarily specialize in South Indian regional influencer marketing including Tamil, Telugu, Malayalam, and Kannada creators, while also executing pan-India campaigns.",
  },
  {
    q: "What industries do you work with?",
    a: "We work with beauty, food, tech, fashion, real estate, education, healthcare, fitness, lifestyle, and D2C brands.",
  },
  {
    q: "Can agencies outsource influencer marketing execution to Incer?",
    a: "Absolutely. Many agencies partner with Incer to manage creator sourcing, influencer coordination, campaign execution, and reporting.",
  },
  {
    q: "How can we get started with Incer?",
    a: "You can contact our team to discuss your campaign goals, target audience, budget, and creator requirements.",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1622782262245-bfb660f4ff93?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  brand: "/images/brand-hero.png",
  brandStrategic: "/images/brand-strategic.png",
  creatorHero: "/images/creator-hero.png",
  about1: "/images/about1.png",
  about2: "/images/about2.png",
  ugc: "/images/ugc.png",
  creator1: "https://images.unsplash.com/photo-1622049605334-72e1e4432346?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  network: "https://images.pexels.com/photos/8452381/pexels-photo-8452381.jpeg?auto=compress&cs=tinysrgb&w=1400",
  agency1: "https://images.pexels.com/photos/6476257/pexels-photo-6476257.jpeg?auto=compress&cs=tinysrgb&w=1400",
  agency2: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1400",
};
